import React, { useMemo } from 'react'
import { useTable, useSortBy } from 'react-table'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { format } from 'date-fns'

import { getAuditType } from '../util/oversightUtils'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

const AuditList = ({  list, minigear }) => {
  const columns = useMemo(
    () => minigear ? [
      {
        Header: 'Affiliate Name',
        accessor: 'affiliateName',
        Cell: ({ value }) => <LgyLink to={`/lgyhub/oversight/audits/${value.id}`}>{value.name}</LgyLink>
      },
      { Header: 'Audit Number', accessor: 'auditNumber' },
      { Header: 'Affiliate ID', accessor: 'affiliateId' },
      { Header: 'Fiscal Year', accessor: 'fiscalYear' },
      { Header: 'Audit Close Date', accessor: 'closeDate' }
    ] : [
      {
        Header: 'Affiliate Name',
        accessor: 'affiliateName',
        Cell: ({ value }) => <LgyLink to={`/lgyhub/oversight/audits/${value.id}`}>{value.name}</LgyLink>
      },
      { Header: 'Audit Number', accessor: 'auditNumber' },
      { Header: 'Affiliate ID', accessor: 'affiliateId' },
      { Header: 'Audit Type', accessor: 'auditType' },
      { Header: 'Affiliate Type', accessor: 'affiliateType' },
      { Header: 'Fiscal Year', accessor: 'fiscalYear' },
      { Header: 'Audit Close Date', accessor: 'closeDate' }
    ],
    [minigear]
  )

  const data = useMemo(
    () =>
      list ? list.map(audit => ({
        affiliateName: { id: audit.id, name: audit.organizationName || 'Unknown' },
        auditNumber: audit.auditingUnitCode === 'M' ? audit.auditNumber : 'N/A',
        affiliateId: audit.organizationId,
        auditType: getAuditType(audit.auditTypeCode),
        affiliateType: audit.organizationEntityTypeId === 1 ? 'Lender' : 'Servicer',
        fiscalYear: audit.auditFiscalYear,
        closeDate: format(audit.closeOutDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })
      })) : [],
    [list]
  )

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    rows
  } = useTable({ columns, data }, useSortBy)

  return (
    <div className='audits-list'>
      <h1>Active list</h1>
      <span className='total-records'>Total list: {list ? list.length : ''}</span>
      <table {...getTableProps()}>
        <thead>
        {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? <MdKeyboardArrowDown size={18} alt='sorted descending'/>
                        : <MdKeyboardArrowUp size={18} alt='sorted ascending' />
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default AuditList